export default __webpack_public_path__ + "f420a952ee6e4259b0f7a834e2abd92b.png";